import React from "react";
import { H2, Subtitle2, colorsLight } from "@coherehealth/common";
import { styled, useTheme, CircularProgress, Container, Dialog, DialogProps } from "@mui/material";

interface Props extends DialogProps {
  open: boolean;
  headingText: string;
  subHeaderText?: string | React.ReactNode;
}

export default function LoadingDialog({ open, headingText, subHeaderText }: Props) {
  const { spacing } = useTheme();
  return (
    <FullScreenDialog fullScreen open={open} sx={{ color: colorsLight.background.light }}>
      <LoadingContainer>
        <CircularProgress size={128} sx={{ color: colorsLight.primary.main }} />
        <div style={{ paddingTop: spacing(5), textAlign: "center" }}>
          <HeroHeading>{headingText}</HeroHeading>
          <HeroText>{subHeaderText}</HeroText>
        </div>
      </LoadingContainer>
    </FullScreenDialog>
  );
}

const LoadingContainer = styled(Container)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  height: "100%",
}));

const HeroHeading = styled(H2)(({ theme }) => ({
  color: theme.palette.text.primary,
}));

const HeroText = styled(Subtitle2)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: "16px",
  lineHeight: "20px",
  paddingTop: theme.spacing(2),
}));

const FullScreenDialog = styled(Dialog)(({ theme }) => ({
  ".MuiDialog-paperFullScreen": {
    backgroundColor: colorsLight.background.light,
  },
}));
